import { render, staticRenderFns } from "./CheckoutNotes.vue?vue&type=template&id=73e5b045&"
import script from "./CheckoutNotes.vue?vue&type=script&lang=js&"
export * from "./CheckoutNotes.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports